import { useMutation, useQueryClient } from "react-query";
import { addEmployeeExpectations } from "~/pages/Editor/EditorStaff/requests/AddEmployeeExpectations/getDataExpectations";

export default function useAddEmployeeExpectations() {
  const queryClient = useQueryClient();

  return useMutation(addEmployeeExpectations, {
    onSuccess: () => {
      queryClient.invalidateQueries(["getDataStaffBonus"]);
    },
  });
}
